module.exports = __webpack_public_path__ + "static/media/Safety_and_Sercurity.837ef217.svg";